import styled from 'styled-components';
export const ArrowContainer = styled.span `
  display: flex;
  width: 30px;
  flex-direction: column;
  align-items: ${({ $dir }) => ($dir === 'left' ? 'flex-start' : 'flex-end')};
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::after {
    overflow: hidden;
    content: '';
    ${({ $dir }) => ($dir === 'left' ? 'left: 1px;' : 'right: 1px;')};

    border-bottom: 2px solid currentColor;
    width: 100%;
    top: calc(50% - 1px);
    position: absolute;
    transform: scaleX(0.66);
    transform-origin: ${({ $dir }) => $dir === 'left' ? 'left center' : 'right center'};
    transition: transform 100ms linear;
  }
`;
